import { Input, Form, Checkbox, FormInstance } from 'antd';
// @ts-ignore
import addressCheck from 'ethereum-checksum-address';

import { AvatarInput } from './seatForm/AvatarInput';

const { Item } = Form;

const walletRules = [
  {
    required: true,
    async validator(field: any, address: string) {
      addressCheck.toChecksumAddress(address);
    },
  },
];

interface SeatFormProps {
  form?: FormInstance;
  initialValues?: any;
  onFinish?: (values: any) => void;
}

export function SeatForm({ form, onFinish, initialValues }: SeatFormProps) {
  const [internalForm] = Form.useForm(form);

  return (
    <Form
      form={internalForm}
      id="seatForm"
      name="seatForm"
      size="large"
      layout="vertical"
      onFinish={onFinish}
      initialValues={initialValues}>
      <Item label="Full Name" name="seatName" rules={[{ required: true, message: 'Seat Name is required' }]}>
        <Input />
      </Item>
      <Item label="Seat Wallet" name="seatWallet" rules={walletRules}>
        <Input />
      </Item>
      <Item valuePropName="checked" name="isAdmin">
        <Checkbox>Is Admin</Checkbox>
      </Item>
      <Item label="Description" name="description">
        <Input.TextArea />
      </Item>
      <Item label="Avatar" name="avatar" validateTrigger="onBlur">
        <AvatarInput />
      </Item>
    </Form>
  );
}
